import React, { useCallback, useMemo, useState } from "react";
import useSupabaseRoomSubscription from "util/useSupabaseRoomSubscription";
import { getOrCreatePlayerId } from "util/utils";
import { Outlet } from "react-router-dom";

const LobbyWrapper = () => {
  const [state, setState] = useState([]);
  const playerId = getOrCreatePlayerId();

  const currentPlayerState = useMemo(
    () => state.find((p) => p.subscriptionId === playerId) || null,
    [state, playerId]
  );

  const { broadcastEvent, updateState } = useSupabaseRoomSubscription({
    subscriptionId: playerId,
    channelName: "LOBBY",
    onEvent: ({ event, payload }) => {
       if (event === "changeTeamName" && currentPlayerState.isHost && payload.sessionId === currentPlayerState.sessionId) {
        let newNames = [...currentPlayerState.teamNames];
        newNames[payload.index] = payload.name;
        updateState({ teamNames: newNames });
      }
    },
    onUpdatePresence: (newState) => {
      setState(newState);
    },
  });

  const sessionsList = useMemo(() => {
    const gameMap = state.reduce((acc, player) => {
      const sessionId = player.sessionId;
      if (!sessionId) {
        return acc;
      }
      if (!acc[sessionId]) {
        acc[sessionId] = {
          sessionId: sessionId,
          playersNum: 0,
        };
      }

      if (player.isHost) {
        acc[sessionId] = {
          ...acc[sessionId],
          gameName: player.gameName,
        };
      }
      acc[sessionId].playersNum += 1;
      return acc;
    }, {})
    
    return Object.values(gameMap).filter((session) => Object.keys(session).includes("gameName"));
  }, [state]);

  const getCurrentGameSettings = useCallback(
    (gameId) => {
      const playersInGame = state.filter((p) => p.sessionId === gameId);
      const host = playersInGame.find((p) => p.isHost);

      if (!host) {
        return null;
      }

      const players = playersInGame
        .filter((p) => p.name) // ignore incomplete presence records
        .map((p) => ({
          id: p.subscriptionId,
          name: p.name,
          team: p.team ?? null,
          ready: !!p.ready,
          isHost: !!p.isHost,
        }));

      return {
        players,
        teamNames: host?.teamNames ?? [],
        gameName: host?.gameName ?? gameId,
        gameLimit: host?.gameLimit ?? null,
      };
    },
    [state]
  );

  const outletContext = {
    playerId,
    sessionsList,
    getCurrentGameSettings,
    currentPlayerState,
    broadcastEvent,
    updateState,
  };

  return <Outlet context={outletContext} />;
};

export default LobbyWrapper;
